import React, { useState, useEffect } from 'react';
import { Header } from '../../Components';
import { HiOutlineExclamationCircle, HiUser, HiUsers } from 'react-icons/hi';
import Logo from '../../assets/Images/logo.png';
import Splash1 from '../../assets/Images/SPLASH 1.png';
import Splash2 from '../../assets/Images/Background_orange.jpeg';

const Champion = (props) => {
  const [splash1Visible, setSplash1Visible] = useState(true);
  const [splash2Visible, setSplash2Visible] = useState(false);
  const [selectedGiocatori, setSelectedGiocatori] = useState(null);
  const [isGiocatoriSet, setIsGiocatoriSet] = useState(false);

  const { setChampion, setGiocatori, setInstruction,
 } = props;

  // useEffect(() => {
  //     const timer1 = setTimeout(() => {
  //         setSplash1Visible(false);
  //         setSplash2Visible(true);
  //     }, 3000);
  //     const timer2 = setTimeout(() => {
  //         setSplash2Visible(false);
  //     }, 5000);

  //     return () => {
  //         clearTimeout(timer1);
  //         clearTimeout(timer2);
  //     };
  // }, []);

  const handleGiocatoriClick = (giocatoriValue) => {
    setSelectedGiocatori(giocatoriValue);
    console.log('Selected Giocatori:', giocatoriValue);
    setIsGiocatoriSet(true);
    setChampion(false)
    // Save the value in state
    setGiocatori(giocatoriValue);
  };



  useEffect(() => {
    if (isGiocatoriSet) {
      setGiocatori(true);
    }
  }, [isGiocatoriSet, setChampion]);

  const next = () => {
    setChampion(false)
    setGiocatori(false)
  }
  const gioca = () => {
    setInstruction(true)
  }
  return (
    <>
      <div>
        {/* {splash1Visible && (
                    <div className="Splash_section">
                        <img src={Splash1} alt="" />
                    </div>
                )}
                {splash2Visible && (
                    <div className="giocatori_section">
                        <div className="main_div">
                            <div className="Splash_section">
                                <img src={Splash2} alt="" />
                            </div>
                        </div>
                    </div>
                )} */}
        {/* {!splash1Visible && !splash2Visible && ( */}
        <div className="giocatori_section">
          <div className="main_div">
            <div className="gio_main_section">
              <div className="Giocatori_Header">
                <div className="header_inner_div Gamberoni_header">
                  <div>
                    <img src={Logo} alt="" className="Gamberoni_Logo" />
                  </div>
                  <div>
                    <HiOutlineExclamationCircle className="icons_size" color="white" size={30} onClick={gioca} />
                  </div>
                </div>
              </div>

              <div className="giocatori_inner_section">
                <div className="giocatori_text_section" >
                  <h1>HAI VINTO!</h1>
                  <p>sei davvero un campione</p>
                  <button onClick={next} className='Nuova_partita'>NUOVA PARTITA</button>
                </div>
                {/* <div className="giocatori_inner_card">
                  <div className="giocatori_card" onClick={() => handleGiocatoriClick('single')}>
                    <div className="giocatori_card_inner">
                      <div>
                        <HiUser className="header_icon icons_size" color="#FF6522" />
                      </div>
                      <div className="giocatori_card_text">
                        <p>1 giocatori</p>
                      </div>
                    </div>
                  </div>
                  <div className="giocatori_card" onClick={() => handleGiocatoriClick('multiple')}>
                    <div className="giocatori_card_inner">
                      <div>
                        <HiUsers className="header_icon icons_size" color="#FF6522" />
                      </div>
                      <div className="giocatori_card_text">
                        <p>2 giocatori</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="Come_si_gioca_text_div">
                  <p>Come si gioca?</p>

                </div> */}

              </div>
            </div>
          </div>
        </div>
        {/* //  )}  */}
      </div>
    </>
  );
};

export default Champion
